import React from 'react'
import { toJS } from 'mobx'


import CancelIcon from '@material-ui/icons/Cancel'

import { MenuItem, Chip, Typography, TextField, Paper } from '@material-ui/core'

import Select, { components } from 'react-select'
import { Creatable } from 'react-select';
import Icon from '@mdi/react'
import { mdiMenuDown } from '@mdi/js'

import './SelectSearch.scss'

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core'

const componentsSelect = {
  Control,
  // Menu,
  MultiValue,
  NoOptionsMessage,
  Option,
  // Placeholder,
  SingleValue,
  ValueContainer,
  ClearIndicator,
  // IndicatorsContainer,
  IndicatorSeparator,
  DropdownIndicator,
}

function IndicatorSeparator(innerProps) {
  return (
    null
    // <span style={{display: "none"}} {...innerProps}/>
  )
}

function DropdownIndicator(props) {
  return (
    <components.DropdownIndicator {...props} className={'dropdown-indicator'}>
      <Icon path={mdiMenuDown} size={1} style={{ height: '24px', marginLeft: '20px' }}/>
    </components.DropdownIndicator>
  )
}

function ClearIndicator(props) {
  // const { innerProps: { ref, ...restInnerProps } } = props;
  // return (
  //   <div {...restInnerProps} ref={ref} >
  //     <div style={{ padding: '0px 5px' }}>
  //       delete
  //     </div>
  //   </div>
  // );
  return null
}

function NoOptionsMessage(props) {
  return (
    <Typography
      color="textSecondary"
      className={'noOptionsMessage'}
      // className={props.selectProps.classes.noOptionsMessage}
      {...props.innerProps}
    >
      {/* {props.options.length ? "Neexistuje položka" : "Textová hodnota"} */}
      Žiadne data
    </Typography>
  )
}

function inputComponent({ inputRef, ...props }) {
  return <div
    ref={inputRef}
    {...props}
  />
}

function Control(props) {
  return (
    <TextField
      label={props.selectProps.formatOptionLabel}
      // style={{ marginTop: "20px"}}
      className={'react-select-text-field'}
      fullWidth
      multiline
      // InputLabelProps={{ shrink: props.selectProps.value.length ? true : false}}
      // InputLabelProps={{ shrink:true }}
      InputLabelProps={{ shrink: props.hasValue || props.menuIsOepn }}
      InputProps={{
        inputComponent,
        inputProps: {
          inputRef: props.innerRef,
          children: props.children,
          ...props.innerProps,
          
        },
      }}
      {...props.selectProps.textFieldProps}
    />
  )
}

function Option(props) {
  return (
    <MenuItem
      buttonRef={props.innerRef}
      selected={props.isFocused}
      component="div"
      className={'option-react-select'}
      style={{
        fontWeight: props.isSelected ? 500 : 400,
      }}
      {...props.innerProps}
    >
      {props.children}
    </MenuItem>
  )
}

function Placeholder(props) {
  return (
    <Typography
      color="textSecondary"
      // className={props.selectProps.classes.placeholder}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  )
}

function SingleValue(props) {
  return (
    <Typography
      // className={props.selectProps.classes.singleValue}
      {...props.innerProps}
      style={{ alignSelf: 'center' }}
    >
      {props.children}
    </Typography>
  )
}

function ValueContainer(props) {
  return <div
    // className={props.selectProps.classes.valueContainer}
    className={'value-container'}
    
    
    // style={{display: "flex", padding: 0, wordBreak: "break-all"}}
    // style={{margin: 0, padding: 0}}
  
  >
    {props.children}
  </div>
}

function MultiValue(props) {
  return (
    <Chip
      tabIndex={-1}
      label={props.children}
      // className={classNames(props.selectProps.classes.chip, {
      //   [props.selectProps.classes.chipFocused]: props.isFocused,
      // })}
      onDelete={props.removeProps.onClick}
      deleteIcon={<CancelIcon {...props.removeProps} />}
      // style={{height: "25px"}}
    />
  )
}

function Menu(props) {
  return (
    <Paper square
      className={'menu-container'}
      {...props.innerProps}>
      {props.children}
    </Paper>
  )
}

const indicatorsContainer = (base, state) => ({
  ...base,
  cursor: 'pointer',
  display: 'flex',
  position: 'absolute',
  right: 0,
  bottom: '0px',
})

const materialTheme = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  overrides: {
    MuiInputLabel: {
      root: {
        color: '#777777 !important',
      },
      
    },
    MuiFormLabel: {
      focused: {
        color: '#777777 !important',
      },
    },
    MuiInput: {
      underline: {
        '&:after': {
          borderBottom: '2px solid black',
        },
      },
    },
    MuiInputBase: {
      multiline: {
        paddingBottom: '3px',
        paddingTop: '3px',
        width: '100%',
      },
    },
    MuiChip: {
      root: {
        marginTop: '2px !important',
        marginRight: '3px !important',
        height: '21px',
      },
      label: {
        wordWrap: 'break-word',
      },
      deleteIcon: {
        height: '19px',
      },
    },
  },
})

const TIMEOUT = 1000

export default class SelectSearch extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  
  timeout = null
  
  componentWillUnmount() {
    clearTimeout(this.timeout)
  }
  
  handleChange = (newValue, actionMeta) => {
    if (this.props.onChange) {
      this.props.onChange(newValue)
      // this.setState({value: newValue})
    }
  }
  handleInputChange = (inputValue, actionMeta) => {
    if (this.props.textParam) {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        let newValue = {
          id: 5,
          label: inputValue,
          value: inputValue,
        }
        this.props.onChange(newValue)
      }, TIMEOUT)
    }
    
  }
  
  onMenuOpen = () => {
    if (this.props.onMenuOpen) {
      this.props.onMenuOpen()
    }
  }
  
  onMenuClose = () => {
    if (this.props.onMenuClose) {
      this.props.onMenuClose()
    }
  }
  
  render() {
    const props = {
      onChange: this.handleChange,
      onInputChange: this.handleInputChange,
      options: this.props.options,
      isMulti: this.props.isMulti,
      value: this.props.value,
      components: componentsSelect,
      styles: { indicatorsContainer: indicatorsContainer },
      placeholder: '',
      formatOptionLabel: this.props.label ? this.props.label : '',
      isClearable: true,
      menuIsOpen: this.props.menuIsOpen,
      onMenuOpen: this.onMenuOpen,
      onMenuClose: this.onMenuClose,
      isDisabled: this.props.isDisabled || false,
    }
    
    return (
      <div className={this.props.className}>
        <MuiThemeProvider theme={materialTheme}>
          {this.props.isCreatable ? (
            <Creatable
              {...props}
            />
          ) : (
            <Select
              {...props}
            />
          )}
        </MuiThemeProvider>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/basic/SelectSearch/SelectSearch.js